import SelectComponent from "../../../ui/select/SelectComponent";
import JobStatusCategory from "../../../../model/job/JobStatusCategory";
import LeadStatusCategory from "../../../../model/lead/LeadStatusCategory";

export type StatusCategoryType = JobStatusCategory | LeadStatusCategory;

export default class SelectStatusCategory extends SelectComponent<StatusCategoryType> {
	matchFilter(element: StatusCategoryType, filter: string): boolean {
		return element.label.toLowerCase().indexOf(filter.toLowerCase()) > -1;
	}

	elementToId(element: StatusCategoryType): string {
		return element.id;
	}

	elementToString(element: StatusCategoryType) {
		return element.value;
	}

	onInputChange(value: string) {
		this.props.onInputChange(value);
	}
}
